import OSpecialBusinessDaySettingList from './index.vue';

OSpecialBusinessDaySettingList.install = app => {
  app.component(OSpecialBusinessDaySettingList.name, OSpecialBusinessDaySettingList);
};

export default OSpecialBusinessDaySettingList;
